<main role="main" class="not-home-page">
    <div class="container">
        <div class="row">
            <div class="col-md-12 index-up">
                <app-breadcrumb></app-breadcrumb>
                <h2>{{description?.Title}}</h2>
                <p  class="text-primary size18 font-weight-semibold">{{description?.Contenu}}
                </p>
                <p  class="font-weight-semibold text-uppercase">{{"societesautorisees.chercher" | translate}}</p>
                <form  class="form-ap" #formFilter="ngForm">
                    <div class="form-row">
                        <!-- <div class="col-md-3">
                            <label for="tag">{{"AppelOffre.motscle" | translate}}</label>
                            <input ngModel name="Objet" class="form-control" id="Objet" type="text" placeholder="{{'AppelOffre.Saisissezmotcles' | translate}}">
                        </div>  -->
                        <div class="col-md-4">
                            <label for="port">{{"societesautorisees.port" | translate}}</label>
                            <select ngModel name="port" class="form-control" id="port">
                                <option value="">{{"societesautorisees.ChoisissezPort" | translate}}</option>
                                <option *ngFor="let r of port" [value]="r">{{r}}</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="prestation">{{"societesautorisees.prestation" | translate}}</label>
                            <select ngModel name="prestation" class="form-control" id="prestation">
                                <option value="">{{"societesautorisees.ChoisissezPrestation" | translate}}</option>
                                <option *ngFor="let c of prestation" [value]="c">{{c}}</option>
                            </select>
                        </div>
                        <!-- <div class="col-md-4">
                            <label  for="DatePlis">{{"societesautorisees.validite" | translate}}</label>
                            <input ngModel name="DatePlis" class="form-control" id="DatePlis" type="date" placeholder="Choisissez une date">
                        </div> -->
                    </div>
                    <button class="btn btn-info" [class.pr-5]="!isArab" [class.pl-5]="isArab" (click)="lancerFilter(formFilter.value)">{{"AppelOffre.LancerRecherche" | translate}}<span class="icon-search"></span></button>
                </form>
            </div>
        </div>
    </div>


    <section  class="c-appels-offres">
        <div class="container">
            <div class="row">
                <div class="col d-flex justify-content-between">
                    <h2 class="size18 text-uppercase mb-3">{{"AppelOffre.ResultatRecherche" | translate}} : </h2>
                    <p class="size18 text-uppercase text-white mt-4 pt-1 mb-3">
                        {{lenth}}
                        {{"societesautorisees.SocieteTrouve" | translate}}</p>
                </div>
            </div>
            <!-- <div class="row slickappel" data-aos="fade-up">
                <div *ngFor="let offres of dataOffres" class="col-md-12">
                    <a *ngFor="let offre of offres" routerLink="{{offre.ID}}"
                        class="block-appels d-flex align-items-start flex-column">
                        <div class="d-flex justify-content-between w-100">
                            <div class="num-appel-offre">{{offre.Title}}</div>
                            <div class="date-appels mt-auto">{{converteDate(offre.Date_x0020_de_x0020_publication)}} </div>
                        </div>
                        <h3 class="titre-appels size18"> {{offre.ObjetAppelOffre}} </h3>
                    </a>
                </div>
            </div> -->
            <table id="offres" class="table table-striped table-bordered" style="width:100%">
                <thead>
                    <tr>
                        <th>{{"societesautorisees.port" | translate}}</th>
                        <th>{{"societesautorisees.prestation" | translate}}</th>
                        <th>{{"societesautorisees.SocieteAutorisee" | translate}}</th>
                        <th>{{"societesautorisees.validite" | translate}}</th>
                        <!-- <th>{{"societesautorisees.autorisation" | translate}}</th> -->
                    </tr>
                </thead>
            </table>
            <div class="row">
                <div class="col-md-12">
                    <p class="text-white size12 mt-4">{{descriptionFooter?.Contenu}}</p>
                    <p class="text-white size12" [innerHTML]="descriptionFooter?.Variables"></p>
                </div>
            </div>
        </div>
        
    </section>
</main>



